import React from 'react';
import { ToastContainer } from 'react-toastify';
import NocNavBar from '../../../../../layouts/noc/NocNavBar';
import EnbSiteIpAllocationBody from './EnbSiteIpAllocationBody';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { admin, NOC } from '../../../../../../utils/config';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import EnbSiteIpAllocationProvider from './context/EnbSiteIpAllocationProvider';
import { VICE_PRESIDENT_FSE } from '../../../../../../utils/departments/helpers';

const EnbSiteIpAllocations = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;
  useCheckTwoDepartments(`${NOC}`, `${VICE_PRESIDENT_FSE}`, `${admin}`, history);
  return (
    <div className="s-layout">
      <EnbSiteIpAllocationProvider>
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="NOC Sheet - ENB Site Ip Allocations" position={firstName} />
          <div className="container">
            <div className="row mt-5">
              <div className="mt-4 col-lg-12 col-md-12 col-sm-12">
                <EnbSiteIpAllocationBody />
              </div>
            </div>
          </div>
        </main>
        <ToastContainer />
      </EnbSiteIpAllocationProvider>
    </div>
  );
};

export default EnbSiteIpAllocations;
